import React, { useState } from 'react';

const API = 'https://khepri.tech/api/v1';

const FAQ = [
  { q: 'Как подключить банк?', a: 'Перейдите в раздел «Банки» и выберите нужный банк. Для подключения потребуется логин в интернет-банке.' },
  { q: 'Как создать договор?', a: 'Перейдите в «Договоры», выберите нишу, шаблон, заполните поля — договор сгенерируется автоматически.' },
  { q: 'Как работает ИИ-чат?', a: 'ИИ-чат использует GigaChat для ответов на вопросы о налогах, договорах, контрагентах. Лимит: 20 запросов/мес бесплатно.' },
  { q: 'Где хранятся мои данные?', a: 'Все данные хранятся на серверах в РФ (152-ФЗ). Подробнее — в Политике обработки ПДн.' },
  { q: 'Как отменить подписку?', a: 'В разделе «Тарифы» нажмите «Отменить подписку». Возврат возможен в течение 14 дней.' },
  { q: 'Как пригласить сотрудника?', a: 'Перейдите в «Команда», введите email и выберите роль. Сотрудник получит ссылку для входа.' },
];

function Support() {
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [openFaq, setOpenFaq] = useState(null);
  const token = localStorage.getItem('khepri_token');

  const submit = async (e) => {
    e.preventDefault();
    try {
      await fetch(API + '/support/ticket', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
        body: JSON.stringify({ subject, message, email }),
      });
      setSent(true);
      setSubject('');
      setMessage('');
      setEmail('');
      setTimeout(() => setSent(false), 5000);
    } catch (err) { console.error(err); }
  };

  return (
    <div>
      <h2 style={{ color: '#F7DE8A' }}>🆘 Поддержка</h2>
      <p style={{ color: '#94A3B8', fontSize: 13, marginTop: 4, marginBottom: 16 }}>
        Мы отвечаем в течение <strong style={{ color: '#F7DE8A' }}>2 часов</strong> в рабочее время.
      </p>

      {/* Контакты */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 10, marginBottom: 20 }}>
        <div style={cardStyle}>
          <div style={{ fontSize: 28, marginBottom: 6 }}>📧</div>
          <div style={{ color: '#F7DE8A', fontWeight: 600, marginBottom: 4 }}>Email</div>
          <a href="mailto:support@khepri.tech" style={{ color: '#94A3B8', fontSize: 13 }}>support@khepri.tech</a>
        </div>
        <div style={cardStyle}>
          <div style={{ fontSize: 28, marginBottom: 6 }}>💬</div>
          <div style={{ color: '#F7DE8A', fontWeight: 600, marginBottom: 4 }}>Telegram</div>
          <a href="https://t.me/khepri_support" target="_blank" rel="noopener noreferrer" style={{ color: '#94A3B8', fontSize: 13 }}>@khepri_support</a>
        </div>
        <div style={cardStyle}>
          <div style={{ fontSize: 28, marginBottom: 6 }}>📞</div>
          <div style={{ color: '#F7DE8A', fontWeight: 600, marginBottom: 4 }}>Телефон</div>
          <span style={{ color: '#94A3B8', fontSize: 13 }}>+7 (999) 123-45-67</span>
        </div>
      </div>

      {/* Форма тикета */}
      <div style={{ padding: 20, background: '#1E293B', borderRadius: 12, border: '1px solid #8A6636', marginBottom: 20 }}>
        <h3 style={{ color: '#F7DE8A', marginBottom: 12 }}>Создать тикет</h3>
        <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 10, maxWidth: 500 }}>
          <input value={email} onChange={e => setEmail(e.target.value)} placeholder="Ваш email" type="email" required style={inputStyle} />
          <input value={subject} onChange={e => setSubject(e.target.value)} placeholder="Тема обращения" required style={inputStyle} />
          <textarea value={message} onChange={e => setMessage(e.target.value)} placeholder="Опишите проблему..." rows={5} required style={{ ...inputStyle, resize: 'vertical' }} />
          <button type="submit" style={{ padding: 14, background: '#F7DE8A', color: '#0F172A', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 700, fontSize: 15 }}>
            📨 Отправить
          </button>
          {sent && <p style={{ color: '#10B981', fontWeight: 600 }}>✅ Тикет создан. Мы ответим в течение 2 часов.</p>}
        </form>
      </div>

      {/* FAQ */}
      <h3 style={{ color: '#F7DE8A', marginBottom: 12 }}>❓ Частые вопросы</h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {FAQ.map((item, i) => (
          <div key={i} style={{ background: '#1E293B', borderRadius: 8, border: '1px solid #8A6636', overflow: 'hidden' }}>
            <button onClick={() => setOpenFaq(openFaq === i ? null : i)} style={{ width: '100%', padding: 14, background: 'none', border: 'none', color: '#F7DE8A', fontSize: 14, fontWeight: 600, textAlign: 'left', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              {item.q}
              <span>{openFaq === i ? '−' : '+'}</span>
            </button>
            {openFaq === i && (
              <div style={{ padding: '0 14px 14px', color: '#94A3B8', fontSize: 13, lineHeight: 1.6 }}>
                {item.a}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

const inputStyle = { padding: 12, background: '#0F172A', border: '1px solid #8A6636', borderRadius: 8, color: '#F8FAFC', fontSize: 14 };
const cardStyle = { background: '#1E293B', padding: 16, borderRadius: 12, border: '1px solid #8A6636', textAlign: 'center' };

export default Support;